export default __webpack_public_path__ + "static/media/inner-digital-ready-infrastructure.6a6f485a.svg";